/**
 * @license Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.
 */

.form-item {
  margin-top: var(--base-spacing);

  display: block;
}

.form-item input {
  padding: calc(var(--base-spacing) / 2) 0;

  border: none;
  border-bottom: 1px solid var(--secondary-text-color);
}

.form-item button {
  background: var(--highlighted-background-color);
  border-radius: 3px;
  padding: calc(var(--base-spacing) / 2);
  margin-right: var(--base-spacing);

  cursor: pointer;
  color: var(--base-text-color);
  font-weight: var(--medium-font-weight);
  overflow: hidden;
  white-space: nowrap;
}

.form-item button:hover {
  background: var(--secondary-background-color);
}

.form-item button:disabled {
  background: var(--secondary-background-color);
  cursor: not-allowed;
  opacity: 0.7;
}
